import { useEffect, useState, useRef } from 'react';
import { repositionCookieBanner } from '@Components/Utilities/SandhillsUtility';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import ActionButton from '@Components/Shared/ActionButton';
import TranslationText from '@Components/Utilities/TranslationText';
import CategoryInformation from '@Components/Shared/CategoryInformation';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import ready from 'document-ready';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { inquiryType } from '@Components/Utilities/SandhillsConstants';
import translator from '@Components/Utilities/Translator';

const EmailModal = loadable(() => import('@Components/Shared/Modals/EmailModal'), true);

const JobDetailsView = (props) => {
    const [samModel, setSamModel] = useState(props.SAMModel);
    const [showEmailModal, setShowEmailModal] = useState(props.SAMModel?.ShowSAMOnLoad || props.SAMModel?.ShowMAOOnLoad);
    const [returnFocusRef, setReturnFocusRef] = useState({});
    const [selectedInquiry, setSelectedInquiry] = useState('emailthis');
    const ref = useRef();

    useEffect(() => {
        const cookieBannerResize = () => {
            repositionCookieBanner('job-details-contact-bar', 1001);
        };

        ready(() => {
            cookieBannerResize();
            window.addEventListener('resize', cookieBannerResize);
        });

        return () => {
            window.removeEventListener('resize', cookieBannerResize);
        };
    }, []);
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const getJobSpecs = () => {
        let specRows = [];
        for (var specName in props.JobDetails.JobSpecs) {
            let formattedSpecName = specName.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            specRows.push(
                <div key={specName} className="data-row">
                    <div className="data-label">{formattedSpecName}</div>
                    <div className="data-value">{props.JobDetails.JobSpecs[specName]}</div>
                </div>
            );
        }
        return specRows;
    };

    const onEmailModalToggle = () => {
        setShowEmailModal(showEmailModal => !showEmailModal);
        if (returnFocusRef && returnFocusRef.current) {
            returnFocusRef.current.focus();
        }
    };

    const openEmailModal = (inquiryType, modalData) => {
        modalData = modalData || {};
        setReturnFocusRef(modalData.ref);
        setSelectedInquiry(inquiryType);
        setShowEmailModal(showEmailModal => !showEmailModal);
        setSamModel({ ...samModel, ...modalData });
    };

    return (
        <div>
            <CategoryInformation {...props.CategoryInformation} />
            <div className="job-details-content">
                <div className='media-buttons'>
                    {props.ShowPrintThis &&
                        <button id='job-list-page-print-this' type='button' className='ts-button print-this des-print-this' onClick={() => window.print()}>
                            <i className='fas fa-print media-buttons__icon'></i><TranslationText tKey="sandhills.print" />
                        </button>}
                </div>
                <ComplexBreadcrumb BreadCrumbModels={props.BreadCrumbs} />
                <div className='job-details-contact-bar'>
                    {props.JobDetails.ContactPhone &&
                        <ActionButton
                            url={'tel:' + props.JobDetails.ContactPhone}
                            className='contact-bar-btn des-phone'
                            iconClass='fas fa-phone-alt fa-flip-horizontal'
                            buttonClass='gtm-noclick'
                            buttonText={<TranslationText tKey='sandhills.callseller' />}
                        />}
                </div>
                {!currentSite.IsMobileAppContext &&
                    <button className='search-results' onClick={() => history.go(-1)}>
                        <i className='fas fa-arrow-left' style={{ fontSize: '1.2em' }} />
                        <TranslationText tKey='sandhills.mobileapps.searchresults' />
                    </button>
                }
                <section className="detail-main-body">
                    <div className="job-info">
                        <h1 className="detail-title">{props.JobDetails.JobTitle}</h1>
                        {props.JobDetails.PayType &&
                            <>
                                <div className="job-wage">{props.JobDetails.PayType}: {props.JobDetails.MinPay} - {props.JobDetails.MaxPay}</div>
                            </>}
                        {props.JobDetails.EmployerName}<br />
                        {(props.JobDetails.EmployerName != props.JobDetails.ContactName) &&
                            <>
                                <strong><TranslationText tKey='sandhills.contact' />:</strong> {props.JobDetails.ContactName}<br />
                            </>}
                        {props.JobDetails.ContactPhone &&
                            <>
                                <a className="job-listings-phone-call" href={"tel:" + props.JobDetails.ContactPhone}>{props.JobDetails.ContactPhone}</a><br />
                            </>}
                        {props.JobDetails.JobLocation}<br />
                        {props.JobDetails.ContactEmail &&
                            <button ref={ref} key={props.LocationID} className='ts-button send-email-btn' onClick={() => openEmailModal(inquiryType.Email)}>
                                <i className='far fa-envelope' />
                                <TranslationText tKey='sandhills.sendemail' />
                            </button>}
                    </div>
                </section>
                <section className="detail-additional-data">
                    {props.JobDetails.JobDescription &&
                        <div className="data-box">
                            <h4><TranslationText tKey='sandhills.description' /></h4>
                            <div className="data-value" dangerouslySetInnerHTML={{ __html: props.JobDetails.JobDescription }}></div>
                        </div>}
                    {props.JobDetails.JobResponsibilities &&
                        <div className="data-box">
                            <h4><TranslationText tKey='sandhills.tradesites.mvc.dutiesandresponsibilities' /></h4>
                            <div className="data-value" dangerouslySetInnerHTML={{ __html: props.JobDetails.JobResponsibilities }}></div>
                        </div>}
                    {props.JobDetails.JobSkills &&
                        <div className="data-box">
                            <h4><TranslationText tKey='sandhills.tradesites.mvc.skills' /></h4>
                            <div className="data-value" dangerouslySetInnerHTML={{ __html: props.JobDetails.JobSkills }}></div>
                        </div>}
                    {props.JobDetails.JobSalaryBenefits &&
                        <div className="data-box">
                            <h4><TranslationText tKey='sandhills.dealerservices.boards.mvc.jobsalaryandbenefits' /></h4>
                            <div className="data-value" dangerouslySetInnerHTML={{ __html: props.JobDetails.JobSalaryBenefits }}></div>
                        </div>}
                    <div className="data-box">
                        <h4><TranslationText tKey='sandhills.tradesites.mvc.jobdetails' /></h4>
                        {props.JobDetails.JobURL &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.joblink' /></div>
                                <div className="data-value"><a target="_blank" rel='nofollow' href={props.JobDetails.JobURL} aria-label={props.JobDetails.JobURL + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{props.JobDetails.JobURL}</a></div>
                            </div>}
                        {props.JobDetails.JobLocation &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.joblocation' /></div>
                                <div className="data-value">{props.JobDetails.JobLocation}</div>
                            </div>}
                        {props.JobDetails.CategoryName &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.jobcategory' /></div>
                                <div className="data-value">{props.JobDetails.CategoryName}</div>
                            </div>}
                        {props.JobDetails.EmploymentTypes &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.typeofemployment' /></div>
                                <div className="data-value">{props.JobDetails.EmploymentTypes}</div>
                            </div>}
                        {props.JobDetails.MinYearsExperience &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.minimumexperienceneededyears' /></div>
                                <div className="data-value">{props.JobDetails.MinYearsExperience}</div>
                            </div>}
                        {props.JobDetails.PayType &&
                            <div className="data-row">
                                <div className="data-label"><TranslationText tKey='sandhills.tradesites.mvc.payrate' /></div>
                                <div className="data-value">{props.JobDetails.PayType} ({props.JobDetails.MinPay} - {props.JobDetails.MaxPay})</div>
                            </div>}
                        {getJobSpecs()}
                    </div>
                </section>
            </div>
            {showEmailModal &&
                <EmailModal
                    {...samModel}
                    toggleEmailModal={onEmailModalToggle}
                    DefaultCultureCode={props.DefaultCultureCode}
                    selectedInquiry={selectedInquiry}
                    JobListingID={props.JobDetails.JobListingID}
                />

            }
        </div>
    );
};

export default JobDetailsView;
global.JobDetailsView = JobDetailsView;